import React, {Component} from 'react';
import {tntRed, tntFadedRed} from '../../theme/tntColors';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

const styles = {
  button: {
    width: 34,
    height: 34,
    padding: 8,
    icon: {
      width: 18,
      height: 18,
    },
  },
};

class DeleteIconButton extends Component {
  render() {
    return (
      <IconButton
        style={Object.assign({}, styles.button, this.props.style)}
        iconStyle={styles.button.icon}
        onTouchTap={this.props.onTouchTap}
      >
        <DeleteIcon color={tntFadedRed} hoverColor={tntRed} />
      </IconButton>
    );
  }
}

export default DeleteIconButton;



// WEBPACK FOOTER //
// ./src/components/DeleteIconButton/DeleteIconButton.js